<template>
    <div class="agency-edit">

        <data-form title="Edit Agency"
                   tag="agency-edit"
                   save-button-label="Save"
                   :field-model="agencyFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/agency/view/${agencyId}`"
                   submit-success-message="Agency updated"
                   submit-error-message="Error updating Agency"
                   :submit-success-route="`/agency/view/${agencyId}`"
                   v-on:changed="formChanged">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import AgencyFields from '@/models/Agency'

/**
 * Page for admin to edit agency information
 */
export default Vue.extend({
    name: 'AgencyEdit',
    props: {
        agencyId: Number,
    },
    data () {
        return {
            agencyFields: AgencyFields,
            fieldGroups: [
                ['name', 'abbreviation'],
                ['ownerRepUsers'],
                ['status'],
            ],
        }
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'agency', this.agencyId,
                ['progAdminUsers', 'ownerRepUsers', 'projectManagerUsers'])
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'agency', modelInstance)
        },
    }
})

</script>

